
import {
  Component, Prop, PropSync, Mixins, Watch,
} from 'vue-property-decorator';
import { debounce } from 'ts-debounce';
import AddressItem from '@/features/shipment/components/createShipment/AddressItem.vue';
import { AddressBookItem } from '@/features/shipment/types';
import { getAddressesBook, getAddressesBookByCountry } from '@/features/shipment/services/addresses-book.services';
import { defaultOffsetLimit } from '@/features/common/raw';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';

@Component({
  components: {
    AddressItem,
  },
})
export default class AddressBookTable extends Mixins(ResponsivenessMixin) {
  @PropSync('loading', { required: false, default: false }) loadingSync!: boolean;

  @Prop({ required: true }) addressBook!: Array<AddressBookItem>;

  @Prop({ required: false, default: '' }) countryCode!: string;

  @Prop({ required: false, default: '' }) search!: string;

  private requestCallCount = 1;

  get itemHeight(): number {
    if (this.isDesktop) {
      return 100;
    }

    return this.isMobile ? 170 : 100;
  }

  @Watch('countryCode')
  @Watch('search')
  private resetPagination(): void {
    this.requestCallCount = 1;
  }

  private fetchMoreAddressItem(event) {
    this.debounceFetchAddressBook(event);
  }

  private debounceFetchAddressBook = debounce(this.fetchAndCommitAddressBook, 200);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private async fetchAndCommitAddressBook(event: any): Promise<void> {
    const element = event.currentTarget || event.target;
    if (element && element.scrollHeight - element.scrollTop === element.clientHeight) {
      this.loadingSync = true;

      const fetcher = this.countryCode ? getAddressesBookByCountry : getAddressesBook;
      const addressesBookItems = await fetcher({
        offset: defaultOffsetLimit * this.requestCallCount,
        search: this.search || undefined,
        countryCode: this.countryCode || undefined,
      });

      if (addressesBookItems.length) {
        this.$emit('append', addressesBookItems);
        this.requestCallCount += 1;
      }

      this.loadingSync = false;
    }
  }
}
